// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"1702":"4d34c113","7222":"18394c63","7937":"de4f6177"}[chunkId] || chunkId) + "." + {"1702":"8d825d982679af9c","5763":"40f93fd1c27875a1","7222":"7f6d72c9ae084229","7937":"c89353303d137a8c"}[chunkId] + ".js";
};